module.exports = __webpack_public_path__ + "img/tag.6a1a9077.png";